@tailwind base;
@tailwind components;
@tailwind utilities;

:host {
  position: relative;
  display: inline-block;
}

:host(:hover) .ids-tooltip {
  visibility: visible !important;
  opacity: 1 !important;
}
